import { Button, Flex, IconWrap, Panel, Text } from "@coaching-culture/ui";
import { useUser } from "auth";
import { FaBan, FaSignOutAlt } from "react-icons/fa";
import { Redirect } from "react-router";

export const DeactivatedUser = () => {
  const [user, setUser] = useUser();

  const logout = () => {
    setUser(null);
  };

  // A plain route (not AuthenticatedRoute, which would redirect a
  // deactivated user back here forever), so check sign-in here.
  if (!user?.isDeactivated) {
    return <Redirect to="/" />;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100vw"
      height="100vh"
      flexDirection={"column"}
      pb={5}
      backgroundColor="page"
    >
      <Panel maxWidth={550} p={5} flexDirection="column" alignItems={"center"}>
        {/* hero icon size, design-lint-ignore */}
        <IconWrap color="danger" icon={FaBan} fontSize="4em" />
        <Text
          as="h1"
          fontSize="page"
          mt={3}
          mb={2}
          fontWeight={600}
          color="black"
          textAlign="center"
        >
          This user has been deactivated
        </Text>
        <Text textAlign="center" color="textMuted" mb={3}>
          This user account has been deactivated by an administrator and can no
          longer use the Coaching Culture Platform.
        </Text>
        <Text textAlign="center" fontWeight={600} mb={4}>
          If you feel this is an error, please contact your system administrator
        </Text>
        <Button onClick={logout} icon={FaSignOutAlt} variant="primary">
          Log out
        </Button>
      </Panel>
    </Flex>
  );
};
